import React from 'react';
import { Box, Grid, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import FEditableGrid, { FEditableGridColumn, FEditableGridPayload } from '../../../components/egrid';

type FieldName = 'sourceCode' | 'scenarioCode' | 'filename';

//type TextFieldName = 'sourceCode' | 'scenarioCode' | 'filename';

type State = {
  sourceCode: string;
  scenarioCode: string;
  filename: string;
  loading: boolean;
};

class BieImportWorkbench extends React.Component<any, State> {

  state: State = {
    scenarioCode: 'DEMO01',
    sourceCode: 'EXCEL',
    filename: 'manual_grid_entry.json',
    loading: false,
  };
   
  gform: FEditableGridColumn[] = [
    { id: 'pdc', label: 'Period', type: 'fa', req: 1, width: 120, cp: {t:'bcs',s:'bieperiodtype'} },
    { id: 'enc', label: 'Entity', type: 'tf', req: 1, width: 150, defaultValue: 'SONABHY' },
    { id: 'lcc', label: 'Location', type: 'fa', req: 1, width: 150, cp: {t:'bcs',s:'bielocation'} },
    { id: 'acc', label: 'Account', type: 'fa', req: 0, width: 130, cp: {t:'bcs',s:'chartofaccounts'}, }, //ops: {slotProps:{paper:{sx:{width:'fit-content'}}}}
    { id: 'drc', label: 'Driver', type: 'fa', req: 0, width: 150,  cp: {t:'bcs',s:'biedriver'} },
    { id: 'ref', label: 'Reference', type: 'tf', req: 1, width: 220 },
    { id: 'qty', label: 'Quantity', type: 'nf', req: 0, width: 120, defaultValue: 0 },
    { id: 'upr', label: 'Unit Price', type: 'nf', req: 0, width: 120, defaultValue: 0 },
    { id: 'amt', label: 'Amount', type: 'nf', req: 0, width: 140, defaultValue: 0 },
    { id: 'dsc', label: 'Description', type: 'tf', req: 0, width: 240 },
  ];

  postBiz = async (payload: any) => {
    const res = await fetch('/biz', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify(payload) });
    const json = await res.json();
    if (!res.ok || json.failure) throw new Error(json.em || 'Request failed');
    return json;
  };

  onSubmit = async (payload: FEditableGridPayload) => {
    const {sourceCode,scenarioCode,filename} = this.state;
    const record = payload.rcd.map((row:any) => ({ scc: scenarioCode, ...row }))
    await this.postBiz({
      s: 'bieimport', 
      a: 'universal', 
      trk: null, 
      soc: sourceCode, 
      scc: scenarioCode,
      rcd: record,
      fnm: filename, fdt: {}, att: {}, exi: { origin: 'FEditableGrid' }, rmk: 'Manual editable grid import',
    });
  };

  onChange0 = (name:FieldName) => (e:any) => {
    const value = (name==='scenarioCode')?e.target.value.toUpperCase():e.target.value;
    this.setState({[name]: value} as Pick<State, FieldName>);
  }

  onChange = (name: FieldName) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    const value = name === 'scenarioCode' ? raw.toUpperCase() : raw;
    this.setState({[name]: value} as Pick<State, FieldName>);
  };

  render(){
    const {sourceCode,scenarioCode,filename} = this.state;

    return (
      <Box sx={{ p: 3 }}>
        <Stack spacing={1} sx={{ mb: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>BIE Editable Import Grid</Typography>
          <Typography variant="body2" color="text.secondary">Spreadsheet-style entry for BIE import rows. The grid compiles rows into canonical JSON before submission.</Typography>
        </Stack>
        <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 4 }}>
              <TextField label="Scenario Code" value={scenarioCode} onChange={this.onChange('scenarioCode')} fullWidth />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <TextField select label="Source" value={sourceCode} onChange={this.onChange('sourceCode')} fullWidth>
                {/* <MenuItem value="EXCEL">EXCEL</MenuItem>
                <MenuItem value="API">API</MenuItem> */}
                <MenuItem value="MANUAL">MANUAL</MenuItem>
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <TextField label="Filename / Batch Name" value={filename} onChange={this.onChange('filename')} fullWidth />
            </Grid>
          </Grid>
        </Paper>
        <FEditableGrid title="Import Rows" gform={this.gform} height={520} onSubmit={this.onSubmit} />
      </Box>
    );
  }
};

export default BieImportWorkbench;
